import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, onMounted, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { numeric, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { EstateMapInterface } from "@/types/EstateMapInterface";
  import { CreateEstateMapInterface } from "@/types/CreateEstateMapInterface";
  import { isPngType, isValidFileSize } from "@/helpers/fileUpload";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstateMapUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const map = ref<EstateMapInterface | null>(null);
  const form = reactive({
    width: 0,
    height: 0,
    file: null,
  });
  const rules = computed(() => {
    return {
      width: { required, numeric, $autoDirty: true },
      height: { required, numeric, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    store.dispatch("estate/getEstateMap", estateId).then((res) => {
      map.value = res.data;
      form.width = map.value.size.width;
      form.height = map.value.size.height;
    });
  });

  function selectFile(e: any) {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isPngType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    form.file = selectedFile;
  }
  function uploadFile() {
    const data = new FormData();

    data.append("file", form.file as File);
    const payload = {
      landownerId: userId,
      estateId,
      data,
    };

    return store.dispatch("estate/uploadEstateMapImg", payload);
  }
  async function updateMap() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    const data: Partial<CreateEstateMapInterface> = {
      size: {
        width: form.width,
        height: form.height,
      },
    };

    if (form.file) {
      data.mapImage = (await uploadFile()).data;
    }

    store
      .dispatch("estate/updateEstateMap", { id: map.value?._id, data })
      .then(() => {
        router.push({
          name: "AdminEstateMap",
          params: { userId, estateId },
        });
      });
  }

const __returned__ = { userId, estateId, map, form, rules, v$, selectFile, uploadFile, updateMap, reactive, computed, onMounted, ref, get useVuelidate() { return useVuelidate }, get numeric() { return numeric }, get required() { return required }, get store() { return store }, get router() { return router }, get EstateMapInterface() { return EstateMapInterface }, get CreateEstateMapInterface() { return CreateEstateMapInterface }, get isPngType() { return isPngType }, get isValidFileSize() { return isValidFileSize } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})